import type Experiments from '@wix/wix-experiments'
import type { Platform } from './contract'

export type Features = ReturnType<typeof createFeatures>

export const createFeatures = ({
  experiments,
  settings: { env },
}: {
  experiments: Experiments
  settings: Platform['settings']
}) => ({
  get fes() {
    return experiments.enabled('specs.wixDataViewer.EnableFES')
  },
  get warmupData() {
    return env.live
  },
  get newCurrentPageIndex() {
    return experiments.enabled('specs.wixDataViewer.NewCurrentPageIndex')
  },
  get fetchOnlyConnectedFields() {
    return (
      experiments.enabled('specs.wixDataViewer.fetchOnlyConnectedFields')
      && !env.livePreview
    )
  },
  get fetchOnlyConnectedFieldsIsBlockedByAnotherApp() {
    return (
      env.veloCodeIsPresentOnCurrentPage
      || env.blocksAppIsPresentOnSite
    )
  },
  get useGetForSchemaBulk() {
    return experiments.enabled('specs.wixDataViewer.useGetForSchemaBulk')
  },
  get deferredIsDead() {
    return experiments.enabled('specs.wixDataViewer.deferredIsDead')
  },
  get enableNewCore() {
    return experiments.enabled('specs.wixDataViewer.EnableNewCore')
  },
  get newCoreFormatters() {
    return experiments.enabled('specs.wixDataViewer.NewCoreFormatters')
  },
  get newCoreReferences() {
    return experiments.enabled('specs.wixDataViewer.NewCoreReferences')
  },
  get newCoreLivePreview() {
    return experiments.enabled('specs.wixDataViewer.NewCoreLivePreview')
  },
  get newCoreExpressions() {
    return experiments.enabled('specs.wixDataViewer.NewCoreExpressions')
  },
  get newCoreImageStaticBinding() {
    return experiments.enabled('specs.wixDataViewer.NewCoreImageStaticBinding')
  },
  get newCoreSiteButtonStaticBinding() {
    return experiments.enabled('specs.wixDataViewer.NewCoreSiteButtonStaticBinding')
  },
  get newCoreClickEventActions1() {
    return experiments.enabled('specs.wixDataViewer.NewCoreClickEventActions1')
    // There are failing tests when running `test:it:csr:core` with the
    // experiment enabled in
    // `packages/dbsm-viewer-app/experiment-overrides.json`.
    //
    // DO NOT OPEN the feature until the failing logic covered by the tests has
    // been fixed.
  },
})
